import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    clinics: {
      data: [],
      isFetchingData: false
    },
    clinic: {
      data: null,
      isFetchingData: false
    },
    reservationTypes: {
      data: [],
      isFetchingData: false
    },
    unitMeasurements: {
      data: [],
      isFetchingData: false
    },
    specializations: {
      data: [],
      isFetchingData: false
    },
    doctors: {
      data: [],
      isFetchingData: false
    },
    permissions: {
      data: {},
      isFetchingData: false
    },
    settings: {
      data: {},
      isFetchingData: false
    },
    homeCurrentDate: {
      data: window.moment()
    }
  },
  getters: {
    clinics (state) {
      return state.clinics.data
    },
    clinic (state) {
      return state.clinic.data
    },
    reservationTypes (state) {
      return state.reservationTypes.data
    },
    unitMeasurements (state) {
      return state.unitMeasurements.data
    },
    specializations (state) {
      return state.specializations.data
    },
    doctorsMeta (state) {
      return state.doctors.data
    },
    permissions (state) {
      return state.permissions.data
    },
    settings (state) {
      return state.settings.data
    },
    homeCurrentDate(state) {
      return state.homeCurrentDate.data
    }
  },
  mutations: {
    clearAllCachedData (state) {
      state.clinic.data = []
      state.reservationTypes.data = []
      state.specializations.data = []
      state.clinics.data = []
      state.unitMeasurements.data = []
      state.doctors.data = []
      state.permissions.data = []
      state.settings.data = []
    },
    isFetchingData (state, { key, value }) {
      state[key].isFetchingData = value
    },
    fetchDataToCache (state, { key, value }) {
      state[key].data = value
    },
    addToCache (state, { key, value }) {
      state[key].data.push(value)
    },
    updateCache (state, { key, value }) {
      let data = state[key].data
      Vue.set(data, data.findIndex(value.id), value)
    },
    delete (state, { key, value }) {
      state[key].data.splice(state[key].data.findIndex(value.id), 1)
    },
    updateRecordRelations (state, { stateKey, objectKey, value, mainRecordId }) {
      let data = state[stateKey].data
      let object = data.find(mainRecordId)
      Vue.set(object, objectKey, value)
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js